import classico from "./classico.wav";
import duplo from "./duplo.wav";
import sino from "./sino.wav";
import suave from "./suave.wav";
import urgente from "./urgente.wav";
import smartphone from "./smartphone.wav";

export const SOUND_LIBRARY = [
  { id: "classico", label: "Clássico", file: classico },
  { id: "duplo", label: "Duplo Bipe", file: duplo },
  { id: "sino", label: "Sino", file: sino },
  { id: "suave", label: "Suave", file: suave },
  { id: "urgente", label: "Urgente", file: urgente },
  { id: "smartphone", label: "Smartphone", file: smartphone },
];

export const DEFAULT_SOUND_ID = "classico";

export const getSoundFile = (id) => {
  const found = SOUND_LIBRARY.find((s) => s.id === id);
  return found ? found.file : SOUND_LIBRARY[0].file;
};
